import { svg } from "lit";
const icon = svg `<path d="M23.0769 29.3788L21.5855 27.8981L28.4808 21.0028H7.5V18.9088H28.4808L21.5684 11.9963L23.0597 10.5156L32.4999 19.9558L23.0769 29.3788Z" fill="currentColor"/>`;
export default icon;
